import React from "react";
import { Box, Typography } from "@mui/material";
import { MzRadio, MzRadioGroup } from "@markaaz/ui/MzRadioControls";

const cardStyles = {
  border: "none",
  marginTop: "20px",
  marginBottom: "auto",
  borderRadius: "8px",
  backgroundColor: "common.white",
  height: "48px",
  width: "184px",
  color: "common.white",
  padding: "20px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "20px",
  justifyContent: "space-between",
  ":hover": {
    cursor: "pointer"
  }
};

const selectedStyles = {
  backgroundColor: "common.white",
  border: (theme) => `1px solid ${theme.palette.blue.c100}`
};

const radioGroupStyles = {
  display: "flex",
  gap: "20px"
};

const wrapStyles = {
  display: "flex",
  alignItems: "center"
};

function Card({ selected, children, onClick }) {
  const sxCard = selected ? { ...cardStyles, ...selectedStyles } : cardStyles;

  return (
    <Box sx={sxCard} onClick={onClick}>
      {children}
    </Box>
  );
}

export default function SftpCard({ value, onPanelChange, cardData }) {
  return (
    <>
      <MzRadioGroup sx={radioGroupStyles} row value={value} onChange={onPanelChange}>
        {cardData?.map((item) => (
          <Card key={item.header} selected={item.header === value} onClick={() => onPanelChange(null, item.header)}>
            <Box sx={wrapStyles}>
              <MzRadio sx={radioGroupStyles} key={item.header} value={item.header} checked={value === item.header} />
              <Typography variant={value === item.header ? "body1B" : "body1"} color="blue.c100" width={"133px"}>
                {item.header}
              </Typography>
            </Box>
          </Card>
        ))}
      </MzRadioGroup>
    </>
  );
}
